var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.6,5c4.9,0,9.8,0,14.7,0c4.6,0.7,9.3,1.2,13.9,2.2C187,10.5,201.4,17,214.1,27c23,18.2,36.3,41.9,39.9,70.9 c2.7,22.1-1.4,43.2-12.3,62.5c-23.1,41.1-46.8,81.9-70.6,122.6c-9.6,16.4-33.2,15.8-42.7-0.7c-22.5-38.8-44.9-77.6-67.2-116.4 c-12.7-22.2-18.5-45.9-14.7-71.6c3-19.7,10.8-37.2,23.7-52.3c16.5-19.3,37.4-31.2,62.5-35.5C135.9,6,139.3,5.5,142.6,5z  M149.9,140.5c21,0.1,38.1-16.9,38.1-38.1c0-21.1-16.9-38.1-38-38.1c-21.1,0-38.1,16.9-38.1,38C111.9,123.5,128.8,140.5,149.9,140.5 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.cb7996dec42fe4ee9816b9e05103dd01.svg";
export { ForwardRef as ReactComponent };